import React from 'react';
import { Modal, Button } from 'antd';

const SubscriptionRestrictionModal = ({ visible, onCancel, onReturnHome }) => {
  console.log("component called==>")
  return (
    <Modal
    className='subcription-modal'
      title="Subscription Access Restricted"
      centered={true}
      visible={visible}
      onCancel={onCancel}
      closable={false}
      footer={[
        <div style={{display: "flex", justifyContent: "space-around", alignItems: "center"}}>
            <Button key="cancel" onClick={onCancel}>
            Cancel
            </Button>,
            {/* <Button key="home" type="primary" onClick={onReturnHome}>
            Return to Home Page
            </Button> */}
        </div>,
      ]}
    >
      <p>You are an iOS user, you cannot access subscription from the web. Please go to the iOS app for manage your subscription.</p>
    </Modal>
  );
};

export default SubscriptionRestrictionModal;